import { Languages } from "../../enums"

export default {
    "SB_EXAMPLE_MODULE_ID": {
        [Languages.EN]: ``,
        [Languages.DE]: ``
    }
}